import "./eventList.css";
import { DataGrid } from "@material-ui/data-grid";
import { DeleteOutline, Create, Visibility } from "@material-ui/icons";
import { Link } from "react-router-dom";
import { useState, useEffect, forwardRef } from "react";
import MuiAlert from "@material-ui/lab/Alert";
import { Snackbar } from "@material-ui/core";
import moment from "moment";
import ConfirmationDialog from "../../components/confirmationDialog/ConfirmationDialog";

export default function EventList() {
  const [data, setData] = useState([]);
  const [delStatus, setDelStatus] = useState(false);
  const [delDialog, setDelDialog] = useState(false);
  const [name, setName] = useState("");
  const [id, setId] = useState("");
  const [alertBar, setAlertBar] = useState({
    open: false,
    success: false,
    message: "",
  });
  const [apiUrl, setApiUrl] = useState(
    `${process.env.REACT_APP_SERVER_URL}/webinar`
  );
  const [selectedRows, setSelectedRows] = useState([]);
  let isAdmin = false;
  if (localStorage.getItem("ud")) {
    isAdmin = JSON.parse(localStorage.getItem("ud")).uadmin;
  }

  const Alert = forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
  });

  useEffect(() => {
    const fetchData = async () => {
      const response = await fetch(apiUrl);
      const returnedData = await response.json();
      if (response.status === 200) {
        return returnedData;
      } else {
        alert(returnedData.error);
      }
    };
    fetchData().then((allData) => {
      if (allData) {
        setData(allData.data.reverse());
      }
    });
  }, [apiUrl]);

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setAlertBar((cur) => ({ ...cur, open: false }));
  };

  const handleDelete = async () => {
    handleDelonCancel();
    const url = `${process.env.REACT_APP_SERVER_URL}/webinar/${id}`;
    const response = await fetch(url, {
      method: "DELETE",
    });
    const result = await response.json();
    if (response.status === 200) {
      setData(data.filter((item) => item._id !== id));
      setAlertBar({
        open: true,
        success: true,
        message: `${name} removed successfully`,
      });
    } else if (response.status === 400) {
      setAlertBar({
        open: true,
        success: false,
        message: `FAILURE: ${name} cannot be removed`,
      });
    } else {
      setAlertBar({
        open: true,
        success: false,
        message: `${result.error}`,
      });
    }
  };
  const handleDelonCancel = () => {
    setDelDialog(false);
    setDelStatus(false);
  };

  const columns = [
    {
      field: "name",
      flex: 1,
      headerName: "Event",
      width: 400,
      renderCell: (params) => {
        return (
          <div className="eventListItem">
            <Link
              to={"/event/view/" + params.row._id}
              className="link eventListView"
            >
              {params.row.name}
            </Link>
          </div>
        );
      },
    },
    {
      field: "when",
      headerName: "Event Date",
      width: 300,
      flex: 1,
      renderCell: (params) => {
        return moment(params.row.when).format("LLL");
      },
    },

    {
      field: "action",
      headerName: "Action",
      width: 150,
      renderCell: (params) => {
        return (
          <>
            <div className="all-actions">
              {isAdmin && (
                <>
                  <div>
                    <Link
                      to={"/event/edit/" + params.row._id}
                      className="link eventListEdit"
                    >
                      <Create className="user-action-btn" />
                    </Link>
                  </div>
                  <div>
                    <DeleteOutline
                      className="eventListDelete"
                      onClick={() => {
                        setDelStatus(true);
                        setName(params.row.name);
                        setId(params.row._id);
                      }}
                    />
                  </div>
                </>
              )}
            </div>
          </>
        );
      },
    },
  ];

  return (
    <>
      <div className="eventList">
        <DataGrid
          rows={data}
          disableSelectionOnClick
          columns={columns}
          autoPageSize
          pagination
          rowHeight={"60"}
          getRowId={(row) => row._id}
          loading={data.length === 0}
          style={{ fontSize: "1rem" }}
          onSelectionChange={(row) => setSelectedRows(row)}
        />
        {setDelDialog && (
          <ConfirmationDialog
            type="delete"
            title="Delete Event"
            message={"Do you want to remove " + name + " from the list?"}
            mainButtonText={"Delete"}
            status={delStatus}
            onCancel={handleDelonCancel}
            onSuccess={handleDelete}
          />
        )}
      </div>
      <Snackbar
        open={alertBar.open}
        autoHideDuration={6000}
        onClose={handleClose}
      >
        <Alert
          severite={alertBar.success ? "success" : "error"}
          onClose={handleClose}
        >
          {alertBar.message}
        </Alert>
      </Snackbar>
    </>
  );
}
